// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"LocaleSwitch_listContainer__xmyFY"};